import { render, staticRenderFns } from "./SystemCallTimeSinglePage.vue?vue&type=template&id=b668a2c2&scoped=true&"
import script from "./SystemCallTimeSinglePage.vue?vue&type=script&lang=js&"
export * from "./SystemCallTimeSinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b668a2c2",
  null
  
)

export default component.exports